import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {Patient, Word} from '../../_models';
import {first} from 'rxjs/operators';
import {WordService} from '../../_services/word.service';

@Component({
  selector: 'app-show-patient',
  templateUrl: './show-patient.component.html',
  styleUrls: ['./show-patient.component.scss']
})
export class ShowPatientComponent {

  @Input() abeille: Patient;
  wordsCount = 0;

  constructor(private wordService: WordService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.abeille) {
        this.abeille = new Patient(this.abeille);

        this.wordService.getByPatientId(this.abeille.id).pipe(first()).subscribe(words => {
            this.wordsCount = (words as Word[]).length;
        });
    }
  }
}
